import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/Check";
import DeleteIcon from "@material-ui/icons/Delete";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { IPaymentMethods } from "../interface/IPaymentMethods";
import "./css/PaymentCardItem.scss";
import { format, parse } from "date-fns";
import { API_DATE_FORMAT } from "@constants";

interface IParams {
    card: IPaymentMethods;
    removeCard(cardId: number): void;
    setDefaultCard(cardId: number): void;
}

export const PaymentCardItem = (props: IParams) => {
    const { card, removeCard, setDefaultCard } = props;
    const expiryDate = card.expirationDate;
    const [hasConfirmModal, setHasConfirmModal] = useState(false);
    const { t } = useTranslation("payment");

    let cardTypeLogoSrc;

    try {
        cardTypeLogoSrc = require(`../../../static/img/paymentCards/${card.type.toUpperCase()}.png`);
    } catch (e) {
        cardTypeLogoSrc = "error";
    }

    const cardPartialDigits = card.partialDigits.match(/.{1,4}/g) ?? [];
    const expiryDateFormatted = format(parse(expiryDate, API_DATE_FORMAT, new Date()), "MMM-yy");

    return (
        <div className="payment-card-container">
            <Modal
                close={() => setHasConfirmModal(false)}
                confirm={() => removeCard(card.paymentMethodId)}
                content={t("cardDeleteMessage")}
                isModalOpen={hasConfirmModal}
                title={t("deletePayment")}
                confirmLabel={t("remove")}
            />
            <Card className="payment-card-wrapper">
                <CardContent>
                    <Grid container spacing={4}>
                        <Grid
                            className="payment-card__type"
                            item
                            style={{ justifyContent: card.default ? "space-between" : "flex-end" }}
                            xs={12}
                        >
                            {card.default && (
                                <Chip color="primary" icon={<CheckIcon fontSize="small" />} label={t("defaultCard")} />
                            )}
                            <img alt={card.type} className="payment-card__image" src={cardTypeLogoSrc} />
                        </Grid>
                        <Grid className="payment-card__infos" item xs={12}>
                            {cardPartialDigits.map((cardDigits, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <Typography color="inherit" key={index} variant="body1">
                                    {cardDigits}
                                </Typography>
                            ))}
                        </Grid>
                        <Grid className="payment-card__infos" item xs={12}>
                            <Typography color="inherit" variant="body1">
                                {card.cardholderName}
                            </Typography>
                            <Typography color="inherit" variant="body1">
                                {expiryDateFormatted}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            {!card.default && (
                <List className="payment-card__actions" component="nav">
                    <Fragment>
                        <ListItem button onClick={() => setHasConfirmModal(true)}>
                            <ListItemIcon>
                                <DeleteIcon />
                            </ListItemIcon>
                            <ListItemText primary={t("remove")} />
                        </ListItem>
                        <ListItem button onClick={() => setDefaultCard(card.paymentMethodId)}>
                            <ListItemIcon>
                                <CheckIcon />
                            </ListItemIcon>
                            <ListItemText color="inherit" primary={t("setDefault")} />
                        </ListItem>
                    </Fragment>
                </List>
            )}
        </div>
    );
};
